export enum DrivingStyleMetric {
    Total = -1,
    HarshBrakingEvents = 0,
    HarshAccelerationEvents = 1,
    HarshCorneringEvents = 2,
    OverIdlingDuration = 3,
    OverTorqueDuration = 4,
    OverAccelerationDuration = 5,
    CoastingInclusiveDuration = 7,
    OverRevDuration = 8,
    BadAnticipationEvents = 9,
    ContextualSpeedingEvents = 10,
    CruiseDuration = 11,
    CruiseInTopGearDuration = 12,
    GreenBandDuration = 13,
    SweetSpotDuration = 14,
    CoastingExclusiveDuration = 15,
    SmokingEventsOverDistance = 16,
    FatigueEventsOverDistance = 17,
    NoSeatBeltEventsOverDistance = 18,
    DriverOnPhoneEventsOverDistance = 19,
    DriverDistractionEventsOverDistance = 20,
    CollisionWarningAndVehicleTooCloseEventsOverDistance = 21
}

export enum DrivingStyleMetricDenominator {
    None = 0,
    PerHundredKm = 1,
    DurationEngineOn = 2,
    DurationDriving = 3
}

export enum DrivingStyleWeightingType {
    Even,
    Simple,
    Custom
}

export enum DrivingStyleMetricCategory {
    CAN,
    Accelerometer,
    ADASDMS,
    Tracking,
    Other
}

export enum MetricMappingWeightingLevel {
    None,
    Low,
    Medium,
    High,
    Critical,
    Custom
}

export enum DrivingStyleType {
    Efficiency,
    Safety,
    All
}

export enum DrivingStyleTypeDescription {
    Efficiency,
    Safety
}
